module.exports = __webpack_public_path__ + "static/media/sprite.319f55dc.svg";